module.exports = "<div class=\"wrapper\">\n  <app-site-header></app-site-header>\n  <app-left-sidemenu></app-left-sidemenu>\n  <div class=\"main-panel\">\n    <div class=\"content\">\n      <div class=\"container-fluid\">\n        <router-outlet></router-outlet>\n      </div>\n    </div>\n    <app-site-footer></app-site-footer>\n  </div>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layouts/site-layout/site-layout.component.html
// module id = ../../../../../src/app/layouts/site-layout/site-layout.component.html
// module chunks = main